import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react'
import Globe from 'react-globe.gl'
import { useSpring, useTransition, animated, config } from '@react-spring/web'
import {
  MeshPhongMaterial,
  MeshMatcapMaterial,
  TextureLoader,
  MeshPhysicalMaterial
} from 'three'
import arcsData from './globe_arcs_count_data.csv'
import flightsData from './globe_flights_data.json'
import hexPolyData from './hex_poly_data.json'
import airportsData from './globe-airports-data.csv'
import countries from './countries.json'

const airports = [
  ...arcsData.map(d => ({
    lat: +d.startLat,
    lng: +d.startLng,
    year: +d.year,
    month: +d.month
  }))
]

const isMobile = window.innerWidth < 768
const darkMode =
  window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches

export const EarthCoverReact = ({ stage }: { stage: number }) => {
  const globeRef = useRef<Globe>()
  const [date, setDate] = useState({
    year: 2020,
    month: 1
  })
  // const [styles, setStyles] = useSpring(() => ({
  //   backgroundColor: '#ffffff',
  //   onChange: ({ value }) => {
  //     console.log(value)
  //   },
  //   config: config.molasses
  // }))
  const globeMaterial = useMemo(() => {
    const texture = new TextureLoader().load(require('./matcap-3.png'))
    // const textureMap = new TextureLoader().load(require('./earth-light.png'))

    return new MeshMatcapMaterial({ matcap: texture })

    // return new MeshPhongMaterial({
    //   shininess: 0,
    //   color: '#777777',
    //   specular: '#000000',
    // })

    // return new MeshPhysicalMaterial(
    //   {
    //     color: '#ffffff',
    //     emissive: '#d4d4d4',
    //     emissiveIntensity: 1.1,
    //     emissiveMap: textureMap,
    //     roughness: 1,
    //     metalness: 1,
    //     reflectivity: 0
    //   }
    // )
  }, [])

  useEffect(() => {
    globeRef.current.controls().enabled = false
  }, [])

  useEffect(() => {
    // setStyles.start({ backgroundColor: stage === 0 ? '#ffffff' : '#ffffff' })

    switch (stage) {
      case 0:
        globeRef.current.pointOfView(
          {
            lat: 20,
            lng: 40,
            altitude: 1.75
          },
          2000
        )
        setDate({
          year: 2020,
          month: 1
        })
        break
      case 1:
        globeRef.current.pointOfView(
          {
            lat: 30,
            lng: 20,
            altitude: 2.15
          },
          2000
        )
        setDate({
          year: 2020,
          month: 1
        })
        break
      case 2:
        globeRef.current.pointOfView(
          {
            lat: 25,
            lng: 15,
            altitude: 2.15
          },
          2000
        )
        setDate({
          year: 2020,
          month: 3
        })
        break
      case 3:
        globeRef.current.pointOfView(
          {
            lat: 20,
            lng: 10,
            altitude: 2.15
          },
          2000
        )
        setDate({
          year: 2020,
          month: 4
        })
        break
      case 4:
        globeRef.current.pointOfView(
          {
            // lat: 46.23691257217752,
            // lng: 6.108970779695503,
            lat: 30,
            lng: 20,
            altitude: 2.15
          },
          2000
        )
        setDate({
          year: 2022,
          month: 1
        })
        break
    }
  }, [stage])

  return (
    <Globe
      ref={globeRef}
      atmosphereColor='#bf649e'
      backgroundColor={darkMode ? '#121212' : '#ffffff'}
      globeMaterial={globeMaterial}
      enablePointerInteraction={false}
      arcsData={[
        ...arcsData.filter(
          d => +d.year === date.year && +d.month === date.month
        )
      ]}
      arcColor={() => '#bf649e99'}
      arcStroke={d => 0.35} // + d.count * 0.05)
      arcDashLength={() => 1}
      arcDashGap={() => 0.2}
      arcDashAnimateTime={() => Math.random() * 4000 + 500}
      arcsTransitionDuration={0}
      globeImageUrl={require(darkMode
        ? './earth-dark-small.png'
        : './earth-light-2-small.png')}
      bumpImageUrl={require('./earth-dem.png')}
      pointsData={[
        ...airports.filter(
          d => +d.year === date.year && +d.month === date.month
        )
      ]}
      pointLat={d => d.lat}
      pointLng={d => d.lng}
      pointColor={d => '#bf649e'}
      pointRadius={d => 0.15}
      pointAltitude={d => 0}
      pointsTransitionDuration={0}
      pointsMerge
    />
  )
}
